import { Building2, Zap, MapPin, RefreshCcw } from "lucide-react";

const SERVICES = [
    {
        icon: Building2,
        title: "Sites Institucionais",
        description:
            "Apresente sua empresa com profissionalismo, credibilidade e uma presença digital alinhada à identidade da sua marca.",
    },
    {
        icon: Zap,
        title: "Landing Pages",
        description:
            "Páginas focadas em apresentar ofertas, serviços ou campanhas de maneira clara e estratégica.",
    },
    {
        icon: MapPin,
        title: "Sites para Negócios Locais",
        description:
            "Soluções digitais para clínicas, lojas, imobiliárias e profissionais que desejam fortalecer sua presença online.",
    },
    {
        icon: RefreshCcw,
        title: "Redesign de Sites",
        description:
            "Modernização visual e estrutural de sites existentes, com atenção à usabilidade, responsividade e experiência do visitante.",
    },
];

export const Services = () => {
    return (
        <section id="servicos" data-testid="services-section" className="py-24 border-b border-[#1e2430]">
            <div className="max-w-6xl mx-auto px-6">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
                    <div>
                        <span className="code-font text-xs text-[#2563eb] uppercase tracking-wider block mb-2">
                            01 / Especialidades
                        </span>
                        <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white">
                            Soluções digitais para o seu negócio.
                        </h2>
                    </div>
                    <p className="text-slate-400 max-w-md text-sm md:text-base leading-relaxed">
                        Cada negócio tem seus objetivos. Criamos experiências digitais pensadas para
                        valorizar sua marca e facilitar a conexão com seus clientes.
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {SERVICES.map((service, index) => (
                        <div
                            key={service.title}
                            data-testid={`service-card-${index}`}
                            className="group p-6 rounded-xl bg-[#111622] border border-[#1e2738] hover:border-[#2563eb]/60 transition-colors flex flex-col justify-between"
                        >
                            <div>
                                <div className="w-10 h-10 rounded-lg bg-blue-950/60 border border-blue-800/40 flex items-center justify-center text-blue-400 mb-6 group-hover:scale-110 transition-transform">
                                    <service.icon className="w-5 h-5" strokeWidth={1.8} />
                                </div>
                                <h3 className="text-lg font-bold text-white mb-2">{service.title}</h3>
                                <p className="text-xs text-slate-400 leading-relaxed mb-6">
                                    {service.description}
                                </p>
                            </div>
                            <a
                                href="#orcamento"
                                data-testid={`service-cta-${index}`}
                                className="text-xs font-semibold text-blue-400 hover:text-blue-300 flex items-center gap-1 transition-colors"
                            >
                                Solicitar orçamento &rarr;
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
